import { ImageComponent } from './components/commonComponents/ImageComponent';
import { NamingComponent } from './components/commonComponents/NamingComponent';
import { BaseComponent } from './components/BaseComponent';
import * as _ from "underscore";
import { getComponentFromSource } from '../generics-helper/getComponentFromSource.generic';
import { ComponentNames } from '../helper/componentNames';

export class InteriorObject {
    components: Array<BaseComponent>;

    public getComponent<T extends BaseComponent>(className: string): T {
        return getComponentFromSource<T>(className, this.components);
    }

    getImageComponent() {
        // return this.getComponent<ImageComponent>("ImageComponent");
        return this.getComponent<ImageComponent>(ComponentNames.imageComponent);
    }

    getName() {
        // return this.getComponent<NamingComponent>("NamingComponent").name;
        return this.getComponent<NamingComponent>(ComponentNames.namingComponent).name;
    }
}